<script setup>
const props = defineProps({
  area: {
    type: String,
    required: true
  }
})

const route = useRoute()
const areaListTitle = `${getPrefectureName(props.area)}のライブカメラ`
const prefList = areaToPrefTable.find(({ key }) => key === props.area).pref_list
</script>

<template>
  <div class="spotlist">
    <CommonPageTitle :title="areaListTitle" />
    <ul class="block">
      <li
        v-for="pref in prefList"
        :key="pref.key"
      >
        <NuxtLink
          :to="`${route.path}${pref.key}/`"
          class="link"
        >
          {{ pref.name }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border-radius: 6px;
    background-color: #eef1f8;
  }
  .link {
    display: flex;
    padding: 7px 10px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 4px #00000026;
    color: #303030;
    font-size: 13px;
    font-weight: 700;
    line-height: 13px;
    @media (any-hover: hover) {
      transition: box-shadow 0.2s ease-in-out;
      &:hover {
        box-shadow: 0 2px 6px #00000073;
      }
    }
  }
}
</style>
